module.exports = __webpack_public_path__ + "img/EXTERIOR-JIMNY-1.495a49ce.jpg";